namespace TabAurous.Production {
    export interface ProductionForm {
        TransDate: Serenity.DateEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        VoucherNo: Serenity.StringEditor;
        ProcessId: Serenity.LookupEditor;
        DepartmentId: Serenity.LookupEditor;
        UserId: Serenity.LookupEditor;
        EmployeeId: Serenity.IntegerEditor;
        FinancialYearId: Serenity.IntegerEditor;
        CompanyId: Serenity.IntegerEditor;
        ItemDetails: ProductionItemsEditor;
    }

    export class ProductionForm extends Serenity.PrefixedContext {
        static formKey = 'Production.Production';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ProductionForm.init)  {
                ProductionForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.StringEditor;
                var w3 = s.LookupEditor;
                var w4 = ProductionItemsEditor;

                Q.initFormType(ProductionForm, [
                    'TransDate', w0,
                    'VoucherTypeId', w1,
                    'VoucherNo', w2,
                    'ProcessId', w3,
                    'DepartmentId', w3,
                    'UserId', w3,
                    'EmployeeId', w1,
                    'FinancialYearId', w1,
                    'CompanyId', w1,
                    'ItemDetails', w4
                ]);
            }
        }
    }
}
